<template>
  <hcm-card
    :resource="resource"
    :externalResource="false"
    :hasSource="false"
    :hasShare="false"
  >
    <div class="wrapper">
      <div v-html="formatText(resource.infoText)"></div>
      <div
        v-html="formatText(resource.acknowledgements)"
        class="acknowledgements"
      ></div>
    </div>
  </hcm-card>
</template>

<script>
import HCMCard from "./HCMCard.vue";
import marked from "marked";

export default {
  components: { "hcm-card": HCMCard },
  props: {
    resource: {
      type: Object,
      required: true
    }
  },
  methods: {
    formatText(text) {
      let t = marked(text);

      // console.log(t);
      return t;
    }
  }
};
</script>

<style scoped>
.acknowledgements {
  margin: 10px 0px;
  text-align: center;
}

::v-deep .acknowledgements > p > a > img {
  height: 30px !important;
}
</style>
